<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener("DOMContentLoaded", function() {
    window.addEventListener('scroll', function() {
        let scrollPos = window.scrollY; // Get the current scroll position

        // Apply a custom property to the #hp-banner
        document.querySelector('#hp-banner').style.setProperty('--scrollPos', scrollPos);
    });
});

// Select the two price elements
const firstPriceDiv = document.querySelectorAll('.price')[0];
const secondPriceDiv = document.querySelectorAll('.price')[1];

// Function to clone the contents of the first price div to the second price div
function copyPriceContent() {
  secondPriceDiv.innerHTML = firstPriceDiv.innerHTML;
}

// MutationObserver to watch for changes within the first price div
const observer = new MutationObserver(copyPriceContent);

// Configure the observer to watch for changes to child nodes and subtree
observer.observe(firstPriceDiv, { childList: true, subtree: true });

// Initial copy to synchronize on page load
copyPriceContent();